import { injectable, inject } from 'inversify';
import { ObjectCompletionHandlerInterface } from './object-completion-handler-interface';
import { SectionInteraction, SectionCompletion } from '@/app/statistics/section/section-progress';
import { SectionProgressUtils, SectionProgressUtilsSymbol } from '@/app/statistics/section/section-progress-utils';
import { createInteractionId } from '../section/section-interaction-utils';

export const TAB_TYPE: string = 'tab';

@injectable()
export class TabsCompletionHandler implements ObjectCompletionHandlerInterface {

  @inject(SectionProgressUtilsSymbol)
  private sectionProgressUtils: SectionProgressUtils;

  public calculateDefaultInteractions($container: any|null): SectionInteraction[] {
    let interactions: SectionInteraction[] = [];
    $('.tab.component', $container).each((index: number, element: any) => {
      const $element: any = $(element);
      const id: string = createInteractionId(TAB_TYPE, $element.attr('id'));
      const title: string = $('.tabs-component', $element).attr('data-title') || 'tab-component';

      const items: { [id: string]: boolean } = {};
      $('.nav-link', $element).each((itemIndex: number) => {
        const itemId: string = this.sectionProgressUtils.createItemId(id, itemIndex);
        items[itemId] = false;
      });

      interactions = [...interactions, {
        id,
        title,
        type: TAB_TYPE,
        completed: false,
        items
      }];
    });

    return interactions;
  }

  public setInteraction(completion: SectionCompletion, interaction: any): SectionCompletion {
    if (interaction.type && interaction.type === TAB_TYPE) {
      const tabId: string = interaction.id;
      const itemId: string = this.sectionProgressUtils.createItemId(tabId, interaction.index);
      completion = this.sectionProgressUtils.setInteractionItemCompleted(completion, tabId, TAB_TYPE, itemId);
    }

    return completion;
  }
}
